import React, { Suspense, useState, useEffect } from 'react'
import PageWrapper from '../Components/Other/PageWrapper'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import NewAppointment from '../Components/AppointmentHistory/NewAppointment'
import { routes } from '../MainPage'
import { CommonApiFun } from '../Redux/Action/index'
function AppointmentHistory(props) {
    let { id } = useParams();
    const dispatch = useDispatch()
    const location = useLocation();
    const navigate = useNavigate();
    const PatientFileInfo = useSelector((state) => state.PatientFileInfo)
    const { appointment, appointment_data, dieses } = PatientFileInfo
    const [state, setState] = useState({ FirstName: "", LastName: '', Description: '', Gender: '', MobileNo: '', Email: '', Address: '', BirthDate: '', error: false, showDatePiker: false, day: '', time: "", activeTab: 1, isLoading: false, res: '', Endtime: '', razorpay_payment_id: '', userImage: '', ImageFile: '', paymentRes: "", appointmnetType: "new", })
    location.state == null && navigate(routes.home)
    const { first_name, last_name, mobile_no, profile_image, gender, age, description, address, email, birth_date, patient_key } = PatientFileInfo.patient
    let past = appointment.filter((a) => { if (moment(moment().format('YYYY-MM-DD')).diff(moment(a.appointment_date), 'days') >= 1) { return a } });
    let Upcoming = appointment.filter((a) => { if (moment(moment().format('YYYY-MM-DD')).diff(moment(a.appointment_date), 'days') < 1) { return a } });
    useEffect(() => {
        if (location.state == null) { navigate(routes.home) } else {
            var data = { file_number: id }
            dispatch(CommonApiFun("api/patient_history/post", JSON.stringify(data))).then(async (res) => {
                setState((prev) => ({ ...prev, fileLoader: false }))

                if (res.status == "success") {
                    var { appointment, patient, appointment_data, dieses } = res.data
                    await dispatch({ type: "PATIENT_FILE_INFO", payload: { appointment, patient, fileId: id, appointment_data, dieses } })
                } else {
                }
            }).catch((e) => {
            })
        }
    }, [location])

    const handleEdit = (e, item) => {
        e.preventDefault();
        navigate(routes.AppointmentHistory + "/" + id + routes.ResheduleTime, { state: { appointment: item, patient_key: patient_key } });
    }
    return (
        <Suspense fallback={<div>loading.......</div>}>
            <PageWrapper className={"index-page"}>
                {/* <AppointmentHistory1></AppointmentHistory1> */}
                <div className="pageWrapper">
                    <div className="web-sect pageBox">
                        <div className="pageBanner">
                            <div className="page-banner-wrap">
                                <div className="pageWrapperItem">
                                    <img src={require("../img/banner-bg.png")} alt="Page Banner" />
                                    <div className="pageBanner-text">
                                        <div className="container">
                                            <div className="pageBanner-content">
                                                <h1>Make Appointment</h1>
                                                <div className="breadcrumbs">
                                                    <div className="container">
                                                        <ul className="list-inline listUnstyle">
                                                            <li>
                                                                <a href='javascript:void(0)' onClick={() => { alert("sdsfs"); navigate(routes.home) }} >
                                                                    <svg
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        viewBox="0 0 32 32"
                                                                    >
                                                                        <path d="m21.82 30h-11.64a5 5 0 0 1 -5.18-4.76v-6.24a1 1 0 0 1 2 0v6.24a3 3 0 0 0 3.18 2.76h11.64a3 3 0 0 0 3.18-2.76v-6.24a1 1 0 0 1 2 0v6.24a5 5 0 0 1 -5.18 4.76zm7.89-13.29a1 1 0 0 0 0-1.42l-13-13a1 1 0 0 0 -1.42 0l-13 13a1 1 0 0 0 1.42 1.42l12.29-12.3 12.29 12.3a1 1 0 0 0 1.42 0z" />
                                                                    </svg>
                                                                    Home
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a href='javascript:void(0)' onClick={() => navigate(routes.makeAppointmnet)}>
                                                                    Make Appointment
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <span>Appointment History Detail</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="MainContent">
                        <div className="container">
                            <div className="row">
                                <div className="past_history">
                                    <div className="assin_doctors">
                                        <div className="assin_doctorsbox">
                                            <div className="assin_doctorsbox-header">
                                                <h4 className="assin_doctorsbox-title">Appointment History</h4>
                                                <a href="javascript:void(0)" className="book_trigger" onClick={() => {
                                                    document.body.classList.add('show-popup');
                                                }}>
                                                    Book a New Appointment
                                                </a>
                                            </div>
                                            <div className="assin_doctorsbox-body">
                                                <div className="assin_doctorsbox-body">
                                                    {appointment.map(({ appointment_date, appointment_end_time, appointment_start_time, created_date, appointment_by }) => {
                                                        var DayDiff = moment(moment().format('YYYY-MM-DD')).diff(moment(appointment_date), 'days')

                                                        return (
                                                            <div className="assin_doctorsbox-item">
                                                                <h4>{appointment_date}</h4>
                                                                <p>{moment(appointment_start_time, "hh:mm").format('LT')}</p>
                                                                <span>{DayDiff >= 1 ? 'Past' : DayDiff == 0 ? 'Today' : 'Upcoming'}</span>
                                                                <span>{appointment_by == 0 ? 'By Online' : DayDiff == 1 ? 'By Call' : 'By Clinic'}</span>
                                                            </div>
                                                        )
                                                    }
                                                    )}


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <NewAppointment appointment_data={appointment_data} appointmentArr={appointment}></NewAppointment>
            </PageWrapper>
        </Suspense>
    );
}

export default AppointmentHistory;